import {
    FolderTwoTone,
    HomeTwoTone,
    LeftOutlined,
    ReadOutlined,
    RightOutlined,
} from '@ant-design/icons';
import { Button, Layout, Menu } from 'antd';
import { ItemType, MenuItemType } from 'antd/lib/menu/interface';
// Temporary: keep the primes table icon import disabled with its menu entry.
// import { ReactComponent as EuroBlueIcon } from 'assets/icons/EuroBlue.svg';
// Temporary: auth access was used by the hidden primes table menu entry.
// import { useAuthContext } from 'contexts/AuthContext';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
// Temporary: AccessType was used by the hidden primes table menu entry.
// import { AccessType } from 'types/User';
import Colors from '../const/colors';
const { Sider } = Layout;

function getColor(condition: boolean) {
  return condition ? Colors.BleuHellio : Colors.GrisClair;
}

interface SideMenuProps {
  collapsed: boolean;
  setCollapsed: (value: boolean) => void;
  isImpersonated: boolean;
}

const SideMenu: React.FC<SideMenuProps> = ({
  collapsed,
  setCollapsed,
  isImpersonated,
}) => {
  const { t } = useTranslation();
  // Temporary: keep the concessionnaire check disabled with the menu entry.
  // const { auth } = useAuthContext();
  const navigate = useNavigate();
  const location = useLocation();
  // const isConcessionnaire =
  //   auth?.user?.accessType === AccessType.CONCESSIONNAIRE;

  const handleCollapse = (value: boolean) => {
    setCollapsed(value);
  };

  const getActiveRoute = () => {
    if (location.pathname === '/') return '/';
    if (location.pathname.startsWith('/dossiers')) return '/dossiers';
    if (location.pathname.startsWith('/ressources')) return '/ressources';
    if (location.pathname.startsWith('/tableau-des-primes')) {
      return '/tableau-des-primes';
    }
    return location.pathname;
  };

  const activeRoute = getActiveRoute();

  const menuItems: ItemType<MenuItemType>[] = [
    {
      key: '/',
      icon: <HomeTwoTone twoToneColor={getColor(activeRoute === '/')} />,
      label: t('menu:home'),
    },
    {
      key: '/dossiers',
      icon: (
        <FolderTwoTone twoToneColor={getColor(activeRoute === '/dossiers')} />
      ),
      label: t('menu:dossiers'),
    },
    {
      key: '/ressources',
      icon: <ReadOutlined color={getColor(activeRoute === '/ressources')} />,
      label: t('menu:ressources'),
    },
    // Temporary: hide the primes table entry from the desktop menu.
    // ...(isConcessionnaire
    //   ? [
    //       {
    //         key: '/tableau-des-primes',
    //         icon: (
    //           <EuroBlueIcon
    //             style={{
    //               color: getColor(activeRoute === '/tableau-des-primes'),
    //             }}
    //           />
    //         ),
    //         label: t('menu:primes_table'),
    //       },
    //     ]
    //   : []),
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={handleCollapse}
      width={205}
      collapsedWidth={80}
      trigger={null}
      data-is-impersonated={isImpersonated ? 'true' : 'false'}
      className="hidden bg-white border-r border-gray-200 sticky top-16 h-[calc(100dvh-64px)] overflow-y-auto z-40 self-start sm:block"
    >
      <Menu
        mode="inline"
        selectedKeys={[activeRoute]}
        items={menuItems}
        onClick={handleMenuClick}
        className="side-menu border-r-0 pt-4"
      />

      <div className="absolute bottom-14 w-full">
        <Button
          type="primary"
          shape="circle"
          icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
          size="small"
          className="absolute -right-0 top-1/2 -translate-y-1/2 !rounded-r-none"
          onClick={() => handleCollapse(!collapsed)}
          aria-label={
            collapsed ? t('menu:expand_sidebar') : t('menu:collapse_sidebar')
          }
        />
      </div>
    </Sider>
  );
};

export default SideMenu;
